const { default: Model } = require("./base/model");

class FobOrder extends Model {
  resourceName() {
    return 'fob_orders';
  }

  fields() {
    return {
      code: '',
      current_status: '',
      shipper_id: '',
      transporter_id: '',
      collection_address_id: '',
      delivery_address_id: '',
      recipient_name: '',
      recipient_document: '',
      recipient_document_type: '',
      shipper: { jsonApi: 'hasOne', type: 'shippers'},
      transporter: { jsonApi: 'hasOne', type: 'transporters'},
      collection_address: { jsonApi: 'hasOne', type: 'addresses'},
      delivery_address: { jsonApi: 'hasOne', type: 'addresses'},
      nf_files: { jsonApi: 'hasMany', type: 'fob_order_nf_files' },
      status: { jsonApi: 'hasMany', type: 'status' },
      occurrences: { jsonApi: 'hasMany', type: 'fob_order_occurrences' },
      expected_delivery_date: '',
    }
  }
}

export default new FobOrder();